import React from 'react';

const ChevronRightIcon = () => {
	return (
		<svg
			data-testid='chevron-right'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M7.81239 15L12.8124 10L7.81239 5L7.1875 5.62489L11.5626 10L7.1875 14.3751L7.81239 15Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ChevronRightIcon;
